import Vue from "vue";
import store from "../store";
import { Message } from "element-ui";
import Router from "vue-router";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      redirect: "/home",
      path: "/"
    },
    {
      path: "/home",
      name: "首页",
      component: () => import("@/view/index/index.vue")
    },
    {
      path: "/introduction",
      name: "产品介绍",
      component: () => import("@/view/introduction/index.vue"),
      meta: {
        needLogin: false,
        needSM: false
      }
    }, {
      path: "/safeguard",
      name: "快速维权中心",
      component: () => import("@/view/safeguard/index.vue"),
      meta: {
        needLogin: true,
        needSM: true
      }
    },
    {
      path: "/charge",
      name: "充值",
      component: () => import("@/view/charge/index.vue"),
      meta: {
        needLogin: true,
        needSM: true
      }
    },
    {
      path: "/dilatation",
      name: "购买套餐",
      component: () => import("@/view/dilatation/index.vue"),
      meta: {
        needLogin: true,
        needSM: true
      }
    },
    {
      path: "/pay",
      name: "支付",
      component: () => import("@/view/pay/index.vue"),
      meta: {
        needLogin: true,
        needSM: true
      }
    },
    {
      path: "/issue",
      name: "套餐刊例",
      component: () => import("@/view/issue/index.vue"),
      meta: {
        needLogin: true,
        needSM: true
      }
    },
    {
      path: "/productList",
      name: "尚品集",
      component: () => import("@/view/productList/index.vue"),
      meta: {
        needLogin: true,
        needSM: false
      }
    },
    {
      path: "/protectCenter",
      name: "保护中心",
      component: () => import("@/view/protectCenter/index.vue"),
      meta: {
        needLogin: true,
        needSM: true
      }
    },

    {
      path: "/tortDetail",
      name: "证据袋详情",
      component: () => import("@/view/tortDetail/index.vue")
    },
    {
      path: "/noticePage",
      name: "上传须知",
      component: () => import("@/view/noticePage/index.vue")
    },
    {
      path: "/powerDetail",
      name: "权利详情",
      component: () => import("@/view/powerDetail/index.vue")
    },
    {
      path: "/vipIndex",
      name: "会员信息",
      component: () => import("@/view/vipIndex/index.vue")
    }
  ]
});
router.beforeEach((to, from, next) => {

  console.log('router:::', to);

  if (JSON.parse(localStorage.getItem("userInfo"))) {
    store.dispatch(
      "getUserinfoByStore",
      JSON.parse(localStorage.getItem("userInfo"))
    );
  }
  let userInfo =
    store.state.userInfo || JSON.parse(localStorage.getItem("userInfo")) || "";

  if (to.path === "/productList" && to.query.token) {
    userInfo = { access_token: to.query.token };
    store.commit("setUserInfo", userInfo);
  }

  if (to.query.channel) {
    localStorage.setItem('channel', to.query.channel);
  } else {
    localStorage.setItem('channel', undefined);
  }
  if (to.meta.needLogin) {
    if (userInfo === '') {
      Message.warning("请先登录");
      next("/");
    } else if (to.meta.needSM && userInfo.realFlag != 1) {
      Message.warning("请先实名认证");
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js